import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce((total, item) => {
      return total + Number(item[field] || 0);
    }, 0);
  };

  const getAverage = (field) => {
    if (!reportsData.length) return 0;

    const total = getTotal(field);
    return Number((total / reportsData.length).toFixed(2));
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.LabTier2:
        const total_jml_discordant_diverif_t2 = getTotal(
          "jml_discordant_diverif_t2",
        );
        const total_slide_dikirim_ke_t2 = getTotal("total_slide_dikirim_ke_t2");
        const total_slide_diuji_oleh_t2 = getTotal("total_slide_diuji_oleh_t2");
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Fasyankes</th>
                <th>Jumlah slide discordance</th>
                <th>Total slide yang dikirim ke tingkat 2</th>
                <th>Total slide yang diuji silang oleh tingkat 2</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  let parasyte = item?.parasyte ?? [];
                  if (item?.slide === "negatif") parasyte = ["Negatif"];
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.fasyankes_id?.split("|")[1]}</td>
                      <td>{item?.jml_discordant_diverif_t2}</td>
                      <td>{item?.total_slide_dikirim_ke_t2}</td>
                      <td>{item?.total_slide_diuji_oleh_t2}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5}>Tidak ada data</td>
                </tr>
              )}

              <tr style={{ backgroundColor: "#43766C", color: "#FFF" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_discordant_diverif_t2}
                </td>
                <td style={{ color: "#FFF" }}>{total_slide_dikirim_ke_t2}</td>
                <td style={{ color: "#FFF" }}>{total_slide_diuji_oleh_t2}</td>
              </tr>
            </tbody>
          </>
        );
      case UserLevel.LabTier3:
        const total_jml_slide_discordance = getTotal("jml_slide_discordance");
        const total_jml_discordant_dikirim_ke_t3 = getTotal(
          "jml_discordant_dikirim_ke_t3",
        );
        const total_jml_discordant_diverif_t3 = getTotal(
          "jml_discordant_diverif_t3",
        );
        const total_slide_dikirim_ke_t3 = getTotal("total_slide_dikirim_ke_t3");
        const total_slide_diuji_oleh_t3 = getTotal("total_slide_diuji_oleh_t3");
        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Kab/Kota</th>
                <th>Fasyankes</th>
                <th>Jumlah slide discordence</th>
                <th>Jumlah slide diskordan yang dikirim ke tingkat 3</th>
                <th>Jumlah slide diskordan yang di verifikasi tingkat 3</th>
                <th>Total slide yang dikirim ke tingkat 3</th>
                <th>Total slide yang diuji silang oleh tingkat 3</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  let parasyte = item?.parasyte ?? [];
                  if (item?.slide === "negatif") parasyte = ["Negatif"];
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.district_id?.split("|")[1]}</td>
                      <td>{item?.fasyankes_id?.split("|")[1]}</td>
                      <td>{item?.jml_slide_discordance}</td>
                      <td>{item?.jml_discordant_dikirim_ke_t3}</td>
                      <td>{item?.jml_discordant_diverif_t3}</td>
                      <td>{item?.total_slide_dikirim_ke_t3}</td>
                      <td>{item?.total_slide_diuji_oleh_t3}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={8}>Tidak ada data</td>
                </tr>
              )}

              <tr style={{ backgroundColor: "#43766C", color: "#FFF" }}>
                <td style={{ color: "#FFF" }} colSpan={3}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{total_jml_slide_discordance}</td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_discordant_dikirim_ke_t3}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_discordant_diverif_t3}
                </td>
                <td style={{ color: "#FFF" }}>{total_slide_dikirim_ke_t3}</td>
                <td style={{ color: "#FFF" }}>{total_slide_diuji_oleh_t3}</td>
              </tr>
            </tbody>
          </>
        );
      default:
        const total_jml_faskes_mikroskopis = getTotal("jml_faskes_mikroskopis");
        const total_jml_faskes_kirim_uji_silang = getTotal(
          "jml_faskes_kirim_uji_silang",
        );
        const total_persen_faskes_uji_silang = getAverage(
          "persen_faskes_uji_silang",
        );
        const total_persen_faskes_uji_silang_baik = getAverage(
          "persen_faskes_uji_silang_baik",
        );
        const total_jml_pemeriksaan_pos_regmal1 = getTotal(
          "jml_pemeriksaan_pos_regmal1",
        );
        const total_jml_pemeriksaan_neg_regmal2_pe = getTotal(
          "jml_pemeriksaan_neg_regmal2_pe",
        );
        const total_pemeriksaan_mikroskopis = getTotal(
          "total_pemeriksaan_mikroskopis",
        );
        const total_jml_slide_pos_di_uji_silang = getTotal(
          "jml_slide_pos_di_uji_silang",
        );
        const total_jml_slide_neg_di_uji_silang = getTotal(
          "jml_slide_neg_di_uji_silang",
        );
        const total_slide_di_uji_silang = getTotal("total_slide_di_uji_silang");
        const total_persen_pemeriksaan_yang_di_uji_silang = getAverage(
          "persen_pemeriksaan_yang_di_uji_silang",
        );
        const total_jml_slide_pos_dikirim = getTotal("jml_slide_pos_dikirim");
        const total_jml_slide_neg_dikirim = getTotal("jml_slide_neg_dikirim");
        const total_jml_diuji_silang_lab_tier2 = getTotal(
          "jml_diuji_silang_lab_tier2",
        );
        const total_jml_diuji_silang_lab_tier3 = getTotal(
          "jml_diuji_silang_lab_tier3",
        );
        const total_jml_pb = getTotal("jml_pb");
        const total_jml_nb = getTotal("jml_nb");
        const total_jml_pp = getTotal("jml_pp");
        const total_jml_np = getTotal("jml_np");
        const total_sensitivitas = getAverage("sensitivitas");
        const total_spesifitas = getAverage("spesifitas");
        const total_jml_spesies_benar = getTotal("jml_spesies_benar");
        const total_jml_spesies_salah = getTotal("jml_spesies_salah");
        const total_akurasi_spesies = getAverage("akurasi_spesies");
        const total_persen_hasil_uji_silang_baik = getAverage(
          "persen_hasil_uji_silang_baik",
        );
        const total_jml_discordance = getTotal("jml_discordance");

        return (
          <>
            <thead>
              <tr>
                <th>No</th>
                {[UserLevel.Fasyankes].includes(currentLevel) && <th>Bulan</th>}
                {[UserLevel.District].includes(currentLevel) && (
                  <th>Fasyankes</th>
                )}
                {[UserLevel.National].includes(currentLevel) && (
                  <th>Provinsi</th>
                )}
                {[UserLevel.Province].includes(currentLevel) && (
                  <>
                    <th>Kab/Kota</th>
                    <th>Jumlah faskes melakukan pemeriksaan mikroskopis</th>
                    <th>Jumlah faskes yang mengirimkan slide uji silang</th>
                    <th>% Faskes melakukan uji silang</th>
                    <th>% Faskes melakukan uji silang hasil baik</th>
                  </>
                )}
                <th>
                  Jumlah pemeriksaan mikroskopis hasil positif (regmal 1
                  mikroskop)
                </th>
                <th>
                  Jumlah pemeriksaan mikroskopis hasil negatif (regmal 2 dan PE)
                </th>
                <th>Total pemeriksaan mikroskopis</th>
                <th>Jumlah sediaan darah positif yang diuji silang</th>
                <th>Jumlah sediaan darah negatif yang diuji silang</th>
                <th>Total pemeriksaan mikroskopis yang diuji silang</th>
                <th>% Pemeriksaan mikroskopis yang diuji silang</th>
                <th>Jumlah slide positif yang dikirim</th>
                <th>Jumlah slide negatif yang dikirim</th>
                {[
                  UserLevel.District,
                  UserLevel.Province,
                  UserLevel.National,
                ].includes(currentLevel) && (
                  <th>
                    Jumlah pemeriksaan mikroskopis yang diuji silang Lab Tingkat
                    2
                  </th>
                )}
                {[UserLevel.Province, UserLevel.National].includes(
                  currentLevel,
                ) && (
                  <th>
                    Jumlah pemeriksaan mikroskopis yang diuji silang Lab Tingkat
                    3
                  </th>
                )}
                <th>Jumlah positif benar</th>
                <th>Jumlah negatif benar</th>
                <th>Jumlah positif palsu</th>
                <th>Jumlah negatif palsu</th>
                <th>Sensitivitas</th>
                <th>Spesifitas</th>
                <th>Jumlah Spesies Benar</th>
                <th>Jumlah Spesies Salah</th>
                <th>Akurasi spesies (%)</th>
                <th>% Hasil uji silang baik</th>
                {[
                  UserLevel.Province,
                  UserLevel.District,
                  UserLevel.National,
                ].includes(currentLevel) && <th>Jumlah discordence</th>}
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {[UserLevel.Fasyankes].includes(currentLevel) && (
                        <td>{monthConverter(item?.month)}</td>
                      )}
                      {[UserLevel.District].includes(currentLevel) && (
                        <td>{item?.fasyankes_id?.split("|")[1]}</td>
                      )}
                      {[UserLevel.National].includes(currentLevel) && (
                        <td>{item?.province_id?.split("|")[1]}</td>
                      )}
                      {[UserLevel.Province].includes(currentLevel) && (
                        <>
                          <td>{item?.district_id?.split("|")[1]}</td>
                          <td>{item?.jml_faskes_mikroskopis}</td>
                          <td>{item?.jml_faskes_kirim_uji_silang}</td>
                          <td>{Number(item?.persen_faskes_uji_silang ?? 0)}</td>
                          <td>
                            {Number(item?.persen_faskes_uji_silang_baik ?? 0)}
                          </td>
                        </>
                      )}
                      <td>{item?.jml_pemeriksaan_pos_regmal1}</td>
                      <td>{item?.jml_pemeriksaan_neg_regmal2_pe}</td>
                      <td>{item?.total_pemeriksaan_mikroskopis}</td>
                      <td>{item?.jml_slide_pos_di_uji_silang}</td>
                      <td>{item?.jml_slide_neg_di_uji_silang}</td>
                      <td>{item?.total_slide_di_uji_silang}</td>
                      <td>
                        {Number(
                          item?.persen_pemeriksaan_yang_di_uji_silang ?? 0,
                        )}
                      </td>
                      <td>{item?.jml_slide_pos_dikirim ?? 0}</td>
                      <td>{item?.jml_slide_neg_dikirim ?? 0}</td>
                      {[
                        UserLevel.District,
                        UserLevel.Province,
                        UserLevel.National,
                      ].includes(currentLevel) && (
                        <td>{item?.jml_diuji_silang_lab_tier2 ?? 0}</td>
                      )}
                      {[UserLevel.Province, UserLevel.National].includes(
                        currentLevel,
                      ) && (
                        <td>{item?.jml_diuji_silang_lab_tier3 ?? 0}</td>
                      )}
                      <td>{item?.jml_pb}</td>
                      <td>{item?.jml_nb}</td>
                      <td>{item?.jml_pp}</td>
                      <td>{item?.jml_np}</td>
                      <td>{item?.sensitivitas ?? 0}</td>
                      <td>{item?.spesifitas ?? 0}</td>
                      <td>{item?.jml_spesies_benar ?? 0}</td>
                      <td>{item?.jml_spesies_salah ?? 0}</td>
                      <td>{item?.akurasi_spesies ?? 0}</td>
                      <td>{Number(item?.persen_hasil_uji_silang_baik ?? 0)}</td>
                      {[
                        UserLevel.Province,
                        UserLevel.District,
                        UserLevel.National,
                      ].includes(currentLevel) && (
                        <td>{item?.jml_discordance}</td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={31}>Tidak ada data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                {[UserLevel.Province].includes(currentLevel) && (
                  <>
                    <td style={{ color: "#FFF" }}>
                      {total_jml_faskes_mikroskopis}
                    </td>
                    <td style={{ color: "#FFF" }}>
                      {total_jml_faskes_kirim_uji_silang}
                    </td>
                    <td style={{ color: "#FFF" }}>
                      {total_persen_faskes_uji_silang}
                    </td>
                    <td style={{ color: "#FFF" }}>
                      {total_persen_faskes_uji_silang_baik}
                    </td>
                  </>
                )}
                <td style={{ color: "#FFF" }}>
                  {total_jml_pemeriksaan_pos_regmal1}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_pemeriksaan_neg_regmal2_pe}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_pemeriksaan_mikroskopis}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_slide_pos_di_uji_silang}
                </td>
                <td style={{ color: "#FFF" }}>
                  {total_jml_slide_neg_di_uji_silang}
                </td>
                <td style={{ color: "#FFF" }}>{total_slide_di_uji_silang}</td>
                <td style={{ color: "#FFF" }}>
                  {total_persen_pemeriksaan_yang_di_uji_silang}
                </td>
                <td style={{ color: "#FFF" }}>{total_jml_slide_pos_dikirim}</td>
                <td style={{ color: "#FFF" }}>{total_jml_slide_neg_dikirim}</td>
                {[
                  UserLevel.District,
                  UserLevel.Province,
                  UserLevel.National,
                ].includes(currentLevel) && (
                  <td style={{ color: "#FFF" }}>
                    {total_jml_diuji_silang_lab_tier2}
                  </td>
                )}
                {[UserLevel.Province, UserLevel.National].includes(
                  currentLevel,
                ) && (
                  <td style={{ color: "#FFF" }}>
                    {total_jml_diuji_silang_lab_tier3}
                  </td>
                )}
                <td style={{ color: "#FFF" }}>{total_jml_pb}</td>
                <td style={{ color: "#FFF" }}>{total_jml_nb}</td>
                <td style={{ color: "#FFF" }}>{total_jml_pp}</td>
                <td style={{ color: "#FFF" }}>{total_jml_np}</td>
                <td style={{ color: "#FFF" }}>{total_sensitivitas}</td>
                <td style={{ color: "#FFF" }}>{total_spesifitas}</td>
                <td style={{ color: "#FFF" }}>{total_jml_spesies_benar}</td>
                <td style={{ color: "#FFF" }}>{total_jml_spesies_salah}</td>
                <td style={{ color: "#FFF" }}>{total_akurasi_spesies}</td>
                <td style={{ color: "#FFF" }}>
                  {total_persen_hasil_uji_silang_baik}
                </td>
                {[
                  UserLevel.Province,
                  UserLevel.District,
                  UserLevel.National,
                ].includes(currentLevel) && (
                  <td style={{ color: "#FFF" }}>{total_jml_discordance}</td>
                )}
              </tr>
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if ([UserLevel.Province, UserLevel.LabTier3].includes(currentLevel)) {
    levelName = "Provinsi";
  } else if ([UserLevel.District, UserLevel.LabTier2].includes(currentLevel)) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, REKAP UJI SILANG</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
